import React from "react";
import { TriangleAlert } from "lucide-react";

const STAGE_COLORS = ["#3B82F6", "#F59E0B", "#10B981"];

export default function ConversionFunnel({ data = [] }) {
  const stages = data.filter((d) => d.name !== "Lost");
  const lost = data.find((d) => d.name === "Lost");
  const max = Math.max(...stages.map((d) => d.value), 1);

  return (
    <div className="py-1">
      <div className="flex flex-col items-center gap-2">
        {stages.map((d, i) => {
          const widthPct = Math.max(34, Math.round((d.value / max) * 100));
          const prev = stages[i - 1];
          const convPct = prev && prev.value > 0 ? Math.round((d.value / prev.value) * 100) : 100;
          return (
            <div key={d.name} className="w-full flex flex-col items-center">
              {i > 0 && (
                <div className="text-[10px] text-zinc-600 mb-1 flex items-center gap-1">
                  <span className="opacity-60">↓</span>
                  <span className={convPct >= 50 ? "text-emerald-400" : "text-amber-400"}>{convPct}% lanjut</span>
                </div>
              )}
              <div
                className="h-12 rounded-xl flex items-center justify-between px-4 shadow-lg transition-all duration-300"
                style={{
                  width: `${widthPct}%`,
                  minWidth: "140px",
                  background: `linear-gradient(135deg, ${STAGE_COLORS[i]}, ${STAGE_COLORS[i]}99)`,
                  boxShadow: `0 4px 16px ${STAGE_COLORS[i]}33`,
                }}
              >
                <span className="text-sm font-semibold text-white">{d.name}</span>
                <span className="text-base font-bold text-white font-heading">{d.value}</span>
              </div>
            </div>
          );
        })}
      </div>

      {lost && (
        <div className="mt-4 pt-3 border-t border-white/5 flex items-center justify-between">
          <div className="flex items-center gap-2 text-xs text-zinc-500">
            <TriangleAlert size={13} className="text-red-400" />
            Keluar dari funnel (Lost)
          </div>
          <span className="text-sm font-semibold text-red-400">{lost.value}</span>
        </div>
      )}
    </div>
  );
}
